var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.25L7.53194 7.53658C8.06087 7.8837 8.32534 8.05726 8.61301 8.12448C8.86712 8.18386 9.13288 8.18386 9.38699 8.12448C9.67466 8.05726 9.93913 7.8837 10.4681 7.53658L17 3.25M4.84 13H13.16C14.5041 13 15.1762 13 15.6896 12.7548C16.1412 12.539 16.5083 12.1948 16.7384 11.7715C17 11.2902 17 10.6601 17 9.4V4.6C17 3.33988 17 2.70982 16.7384 2.22852C16.5083 1.80516 16.1412 1.46095 15.6896 1.24524C15.1762 1 14.5041 1 13.16 1H4.84C3.49587 1 2.82381 1 2.31042 1.24524C1.85883 1.46095 1.49168 1.80516 1.26158 2.22852C1 2.70982 1 3.33988 1 4.6V9.4C1 10.6601 1 11.2902 1.26158 11.7715C1.49168 12.1948 1.85883 12.539 2.31042 12.7548C2.82381 13 3.49587 13 4.84 13Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.9addce138984d56af47fd0d03e2639e7.svg";
export { ForwardRef as ReactComponent };